export enum USER_TYPE {
  admin = "Admin",
  caterer = "Caterer",
  customer = "Customer"
}
